import { queryOptions } from '@tanstack/react-query';
import type { AppListResponse, AppResponseDTO } from '@monksflow/platform-api-sdk';

import { PlatformApi } from '@/lib/api/platform/platformSdk';
import { logger } from '@/lib/utils/logger';

const USER_APPS_QUERY_KEY = ['user-apps', 'organization-apps'] as const;

const getOrganizationApps = async (): Promise<AppResponseDTO[]> => {
  try {
    const response = await PlatformApi.platformApi.get<AppListResponse>('/users/me/apps');
    return response.data.data;
  } catch (error) {
    logger.error('Failed to fetch organization apps:', error);
    return [];
  }
};

export const organizationAppsQuery = () =>
  queryOptions({
    queryKey: USER_APPS_QUERY_KEY,
    queryFn: getOrganizationApps,
  });
